/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import {
    Component, ElementRef, QueryList, ContentChildren
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputAccessor } from '../../input-accessor';
import { FeRadio } from '../fe-radio/fe-radio';
import { Mixin } from '../../../mixins/Mixin';
import { Filterable } from '../../../mixins/Filterable';


@Component({
    selector: 'fe-radio-group',
    template: require('./fe-radio-group.html'),
    styles: [require('./fe-radio-group.less')],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: FeRadioGroup, multi: true}
    ],
})

@Mixin([Filterable])
export class FeRadioGroup extends  InputAccessor {

    @ContentChildren(FeRadio) feRadioList: QueryList<FeRadio>;

    constructor(public elementRef: ElementRef) {
        super();
    }

    set innerValue(value: any) {
        super.updateValue(value);
        if (this.feRadioList) {
            this.feRadioList.forEach((item) => {
                item.innerUiRadio.innerValue = value;
            });
        }
    }

    public prepareValueHook() {}

    ngAfterContentInit() {
        this.feRadioList.forEach((item) => {
            item.innerUiRadio.registerOnChange(this.writeValue.bind(this));
            item.innerUiRadio.name = this.name;
        });


    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/form-elements/fe-radio-group/fe-radio-group.ts